import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ViewToggle: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isProjects = location.pathname.startsWith('/projects');
  const isHubspotDeals = location.pathname.startsWith('/hubspot-deals');

  return (
    <div className="flex items-center space-x-1 rounded-2xl border border-black/10 bg-white/80 p-1 shadow-sm backdrop-blur dark:border-white/10 dark:bg-gray-800/80">
      <button
        type="button"
        onClick={() => navigate('/projects')}
        className={`rounded-xl px-4 py-2 text-xs font-medium min-h-[40px] transition-all ${
          isProjects
            ? 'bg-gradient-to-r from-[var(--color-primary)] to-[var(--color-secondary)] text-white shadow-sm'
            : 'text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700'
        }`}
      >
        Kacheln
      </button>
      <button
        type="button"
        onClick={() => navigate('/hubspot-deals')}
        className={`hidden rounded-xl px-4 py-2 text-xs font-medium min-h-[40px] transition-all sm:inline-flex ${
          isHubspotDeals
            ? 'bg-gradient-to-r from-[var(--color-primary)] to-[var(--color-secondary)] text-white shadow-sm'
            : 'text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700'
        }`}
      >
        Liste
      </button>
    </div>
  );
};

export default ViewToggle;
